export default "__VITE_ASSET__BMYYwe$h__"